module.exports = __webpack_public_path__ + "img/81.10.pH.88aa0ad5.png";